module.exports = __webpack_public_path__ + "static/media/11NEPAD1.8cc4d505.jpg";